import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MetronavixLanding from './components/MetronavixLanding';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import PropertyDetails from './components/PropertyDetails';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MetronavixLanding />} />
        <Route path="/terms/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms/privacy-policy.html" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/property/:id" element={<PropertyDetails />} />
        <Route path="/terms.html" element={<TermsAndConditions />} />
      </Routes>
    </Router>
  );
}

export default App;
